import React, { useCallback, useEffect, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import * as opdCentersCrud from '../../../configurations/crud/opdCentersCrud'
import { useToast } from '../../controls/Toast/ToastService'
import {
  MdErrorOutline,
  MdSearch,
  MdClose,
  MdOutlineSupportAgent,
  MdOutlineLocationOn,
  MdOutlineAccessTime,
  MdPlayArrow,
  MdSkipNext,
  MdOutlinePersonOff,
  MdOutlineCancel,
  MdOutlineFreeBreakfast,
  MdOutlinePowerSettingsNew,
  MdCampaign,
  MdVolumeUp,
  MdVolumeOff,
  MdStop,
} from 'react-icons/md'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import { GetById } from '../../../configurations/crud/opdCentersCrud'
import { GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus'
import { FaCircleInfo } from "react-icons/fa6";
import { IoMdAdd } from "react-icons/io";
import { FaUserMd, FaUserPlus, FaHeartbeat } from "react-icons/fa";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import AddOpdOffline from './AddOpdOffline'
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5'
import ReceptionConfirmed from './ReceptionConfirmed'
import ReceptionEmergency from './ReceptionEmergency'
import ReceptionRegistered from './ReceptionRegistered'
import WarningPopUp from './WarningPopUp'
import { VscDebugDisconnect } from 'react-icons/vsc'
import LoadingContainer from '../../controls/LoadingContainer'
import StatusContainer from '../../controls/StatusContainer'
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType'
import { allowSleep, keepAwake } from '../../../configurations/native/screenTime'
import { useKeepAwake } from 'react-keep-awake';
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { PiPlugsConnectedFill } from "react-icons/pi";
import DaillyShortReport from '../report/DaillyShortReport'
import useLiveRoom from './liveconfig/useLiveRoom'
import useBell from './liveconfig/useBell'
import useSpeak, { buildAnnouncement, speakableText } from './liveconfig/useSpeak'
import SoundGate from './SoundGate'
import AnnouncePopUp from './AnnouncePopUp'
import { MSG, packMsg, parseMsg, isNoticeAlive, noticeLabel } from './liveMsg'

// Display screen wali hi key — usually dono device par same language rakhi jaati hai
const VOICE_KEY = 'display_voice_lang'
// reception ke apne speaker se bhi bolwana hai ya sirf Display se
const SPEAK_HERE_KEY = 'reception_speak_here'
// chalu custom announcement, taaki reception refresh hone par bhi banner dikhta rahe
const NOTICE_KEY = 'reception_notice'

const ANNOUNCE_OPTS = { numberStyle: 'natural', repeatNumber: true }

export default function Reception({ }) {
  const { start, end } = useGlobalLoader()
  const { centerid } = useParams()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [isOpenPop, setIsOpenPop] = useState(false)
  const [isOpenUnavailable, setIsOpenUnavailable] = useState(false)
  const [isOpenAbsent, setIsOpenAbsent] = useState(false)
  const [currentSavedData, setCurrentSavedData] = useState()
  const [serachPatient, setSerachPatient] = useState("")
  const [isSerachPatient, setIsSerachPatient] = useState(0)

  const [eventMessage, setEventMessages] = useState("");

  const [centerData, setCenterData] = useState();
  const [doctorStatus, setDoctorStatus] = useState(1);

  const [currentData, setCurrentData] = useState();
  const [nextPatientData, setNextPatientData] = useState();

  const [viewUsers, setViewUsers] = useState(1);
  const [tabRefresh, setTabRefresh] = useState(0);   // tab click par list dobara load karne ke liye
  const [isPrint, setIsPrint] = useState(false);
  const [isDailyUpdate, setIsDailyUpdate] = useState(0)
  const loginInfo = getLoginInfo()

  // ======== Shot Ke =========
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ctrl + S
      if (e.shiftKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        NextPatient();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useKeepAwake()
  useEffect(() => {
    keepAwake()
    return () => {
      allowSleep()
    }
  }, [])

  // ===== sounds =====
  const { ring, unlock, unlocked } = useBell({
    bell: '/assets/audio/mixkit-cartoon-door-melodic-bell-110.wav',
    staff: '/assets/audio/staff.wav',
    emergency: '/assets/audio/emergency.wav',
  })

  // ===== voice (optional: reception device khud bole) =====
  const voiceLang = (() => {
    try { return localStorage.getItem(VOICE_KEY) || 'hi-IN' } catch (e) { return 'hi-IN' }
  })()
  const [speakHere, setSpeakHere] = useState(() => {
    try { return localStorage.getItem(SPEAK_HERE_KEY) === '1' } catch (e) { return false }
  })
  const { speak, primeSpeech, stop, supported } = useSpeak({ lang: voiceLang, rate: 0.9 })
  // hi-IN voice data missing ho to Devanagari akshar-akshar padha jata hai -> English me bolo
  const canHindi = voiceLang === 'hi-IN' && supported

  // ek hi tap se bell + voice dono unlock
  const unlockAll = () => {
    unlock()
    primeSpeech()
  }

  const toggleSpeakHere = () => {
    setSpeakHere(prev => {
      const next = !prev
      try { localStorage.setItem(SPEAK_HERE_KEY, next ? '1' : '0') } catch (e) { /* ignore */ }
      if (next) primeSpeech(); else stop()
      return next
    })
  }

  const ringBellStaff = useCallback(() => {
    ring('staff')
    toast.open(
      <div><span className='font-bold'>Calling STAFF In.</span></div>,
      <MdErrorOutline />, "info", 10000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ring])

  const ringBellEmergency = useCallback(() => {
    ring('emergency')
    toast.open(
      <div><span className='font-bold'>Please sent EMERGENCY OPD In.</span></div>,
      <MdErrorOutline />, "danger", 10000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ring])

  // ===== live room =====
  const handleMessage = (message) => {
    const { code } = parseMsg(message)   // payload wale messages ("50|{...}") bhi safe rahein
    switch (code) {
      case "1": { GetCenterDetails(); break; }
      case "2": { GetPatientWhoNext(); GetPatientInTheCabin(); setIsDailyUpdate(pre => pre + 1); setIsSerachPatient(pre => pre + 1); break; }
      //case "5": { ring('bell'); break; }
      case "25": { ringBellEmergency(); break; }
      case "35": { ringBellStaff(); break; }
      default: break;
    }
  }

  const refreshAll = () => {
    GetCenterDetails()
    GetPatientInTheCabin()
    GetPatientWhoNext()
  }

  const { isConnected, sendMessage, reconnect } = useLiveRoom({
    user: loginInfo.userName + "_" + centerid + "_Reception",
    room: loginInfo.userName + "_" + centerid,
    onMessage: handleMessage,
    onRejoin: refreshAll,     // reconnect ke baad data phir se sync
  })

  const reConnect = async () => {
    await reconnect()
    unlockAll()
    toast.open("Connected", <VscDebugDisconnect />, "success")
  }

  // send fail ho to reception ko pata chale
  const notify = (ok) => {
    if (!ok) toast.open("Live connection down — screen refresh karein", <MdErrorOutline />, "danger", 5000)
  }

  // ===== custom announcement =====
  // Reception likhta hai, Display bolti hai. Repeat ka timer Display par chalta hai,
  // isliye reception band ho jaye ya screen lock ho jaye tab bhi announcement chalti rehti hai.
  const [isOpenAnnounce, setIsOpenAnnounce] = useState(false)
  const [notice, setNotice] = useState(() => {
    try {
      const raw = localStorage.getItem(NOTICE_KEY)
      const n = raw ? JSON.parse(raw) : null
      return isNoticeAlive(n) ? n : null
    } catch (e) { return null }
  })

  // repeat ka time khatam hote hi banner khud hat jaye
  useEffect(() => {
    if (!notice?.everyMin || !notice.stopAfterMin) return
    const left = notice.startedAt + notice.stopAfterMin * 60000 - Date.now()
    const t = setTimeout(() => {
      setNotice(null)
      try { localStorage.removeItem(NOTICE_KEY) } catch (e) { /* ignore */ }
    }, Math.max(left, 0))
    return () => clearTimeout(t)
  }, [notice])

  const sendNotice = async (n) => {
    // repeat wali hi yaad rakhni hai, one-time bolke khatam
    if (n.everyMin) {
      setNotice(n)
      try { localStorage.setItem(NOTICE_KEY, JSON.stringify(n)) } catch (e) { /* ignore */ }
    }
    // reception ka apna speaker on hai to yahan bhi ek baar bol do (message ki apni language me)
    if (speakHere) {
      stop()
      speak(speakableText(n.text, { hindi: n.lang === 'hi-IN' }), {
        interrupt: true,
        dedupeMs: 0,
        lang: n.lang,
      })
    }
    const ok = await sendMessage(packMsg(MSG.NOTICE_START, n))
    notify(ok)
    if (ok) toast.open(
      n.everyMin ? `Announcement on — ${noticeLabel(n)}` : "Announcement sent",
      <MdCampaign />, "success", 4000)
  }

  const stopNotice = async () => {
    setNotice(null)
    try { localStorage.removeItem(NOTICE_KEY) } catch (e) { /* ignore */ }
    stop()
    notify(await sendMessage(MSG.NOTICE_STOP))
    toast.open("Announcement stopped", <MdStop />, "info", 3000)
  }

  // ===== dobara pukaro (current + next dono) =====
  // "40" = Display current patient ka naam dobara bole
  // "41" = Display next patient ka naam dobara bole
  // (Display 1.2-1.5 sec baad bolta hai taaki bell overlap na ho)
  const announce = async (data, kind) => {
    if (!data?.patientName) {
      toast.open(
        kind === 'cabin' ? "Cabin me abhi koi patient nahi hai" : "Next patient abhi koi nahi hai",
        <MdErrorOutline />, "info")
      return
    }
    if (speakHere) {
      stop()
      speak(buildAnnouncement(data, kind, { hindi: canHindi, ...ANNOUNCE_OPTS }), {
        interrupt: true,
        dedupeMs: 0,   // wahi text hai, dedupe skip karna zaroori hai
      })
    }
    notify(await sendMessage(kind === 'cabin' ? "40" : "41"))
  }

  const AnnounceCabin = async () => await announce(currentData, 'cabin')
  const AnnounceNext = async () => await announce(nextPatientData, 'next')

  useEffect(() => {
    GetPatientInTheCabin()
    GetPatientWhoNext()
    GetCenterDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GetPatientInTheCabin = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetPatientInTheCabin({
      DoctorId: loginInfo.doctorId,
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
      } else {
        setCurrentData()
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setCurrentData()
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const NextPatient = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.NextPatient({
      CenterId: centerid
    }).then(async res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        await sendMessage("2")
        notify(await sendMessage("5"))
        setIsOpenPop(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenPop(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenPop(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const SetToAbsent = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.SetToAbsent({
      CenterId: centerid,
      Id: currentData.id
    }).then(async res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        await sendMessage("4")
        notify(await sendMessage("5"))
        setIsOpenAbsent(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenAbsent(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenAbsent(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const PatientUnavailable = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.PatientUnavailable({
      CenterId: centerid,
      Id: currentData.id
    }).then(async res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        await sendMessage("3")
        notify(await sendMessage("5"))
        setIsOpenUnavailable(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenUnavailable(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      setIsOpenUnavailable(false)
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const GetPatientWhoNext = () => {
    setLoding(true)
    start()
    try {
      opdRegisteredCrud.GetPatientWhoNext({
        DoctorId: loginInfo.doctorId,
        CenterId: centerid
      }).then(res => {
        let mdata = res.data
        if (mdata.result.succeeded) {
          setNextPatientData(mdata.data)
        } else {
          setNextPatientData()
        }
        setLoding(false)
        end()
      }).catch(errors => {
        setNextPatientData()
        setLoding(false)
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      })
    }
    catch (error) {
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    }
  }

  const addOpdOffline = (param, setValues) => {
    setLodingCrud(true)
    start()
    opdRegisteredCrud.AddOfline(param).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentSavedData(mdata.data)
        setValues({
          opdCenterId: centerid,
          patientName: "",
          mobile: "",
          bloodGroup: "N/A",
          bloodPressure: "",
          weight: "",
          age: "",
          gender: 0,
          type: 0,
          note: "",
          patientBond: "Cash",
          patientType: "Normal",
          patientAddress: ""
        })
        setIsPrint(true)
        toast.open("Opd added successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  const GetCenterDetails = () => {
    setLoding(true);
    start()
    GetById(centerid)
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setDoctorStatus(mdata.data.doctorStatus)
          setCenterData(mdata.data);
        } else {
          setCenterData();
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setCenterData();
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }

  // status badalne par sirf "1" bhejte hain — Display khud center details laakar
  // status ki announcement bolti hai (Doctor screen se badle tab bhi wahi hota hai)
  const GetDoctorChangeStatus = (s) => {
    setLoding(true)
    start()
    opdCentersCrud.DoctorChangeStatus({
      Status: s,
      Id: centerid
    }).then(async res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setDoctorStatus(s)
        notify(await sendMessage("1"))
        toast.open("Doctor is " + GetEDoctorStatusName(s), <FaCircleInfo />, "info")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  // ---- config ----
  const DOCTOR_STATES = [
    { id: 1, label: "In The Cabin", Icon: FaUserMd, color: "bg-green-500" },
    { id: 4, label: "On Rest", Icon: MdOutlineFreeBreakfast, color: "bg-orange-500" },
    { id: 0, label: "Offline", Icon: MdOutlinePowerSettingsNew, color: "bg-red-500" },
  ]
  const TABS = [
    { id: 1, label: "Registered", Icon: FaUserPlus, color: "bg-blue-500" },
    { id: 2, label: "Confirmed", Icon: HiOutlineClipboardCheck, color: "bg-green-500" },
    { id: 3, label: "Emergency", Icon: FaHeartbeat, color: "bg-red-500" },
  ]
  const searchScope = viewUsers == 1 ? "registered" : viewUsers == 2 ? "confirmed" : "emergency"

  const doSearch = () => setIsSerachPatient(pre => pre + 1)

  // tab click par uska data har baar fresh aaye.
  // tabRefresh key me jata hai -> component remount -> mount wala fetch dobara chalta hai
  // (isi tab par dobara click karne par bhi kaam karta hai)
  const selectTab = (id) => {
    setViewUsers(id)
    setSerachPatient("")          // pehle search box khali
    setTabRefresh(pre => pre + 1)
    doSearch()                    // phir fresh data (child ka search/refresh effect bhi trigger)
  }

  // shared patient block (current + next)
  const PatientBody = ({ data }) => (
    <>
      <div className="text-2xl font-bold sm:text-3xl">{data.patientName}</div>
      <div className="mt-2 flex flex-wrap items-center justify-center gap-2">
        <span className="text-sm opacity-70">No.:</span>
        <span className="text-3xl font-bold sm:text-4xl">{data.confirmedAllotedNumber}</span>
        {data.confirmedAllotedNumber != data.opdNumberAlloted &&
          <span className="text-sm font-normal opacity-70">/{data.opdNumberAlloted}</span>}
        <StatusContainer bg={ETypeBg(data.type)} text={GetETypeName(data.type)} />
      </div>
      <div className="mt-2 text-sm opacity-70">Ref No. {data.id} {data.registeredIdForRef && "/" + data.registeredIdForRef}</div>
    </>
  )

  return (
    <Container>
      <div className="flex w-full flex-col px-2 sm:px-4">

        <SoundGate unlocked={unlocked} unlock={unlockAll} className="mb-2" />

        {/* ===== Header ===== */}
        <Card
          isBorder={true}
          isBack={true}
          title={
            <div className="flex w-full items-center gap-2">
              <button
                onClick={reConnect}
                title={isConnected ? "Live · tap to reconnect" : "Disconnected · tap to reconnect"}
                className={`relative grid h-8 w-8 place-items-center rounded-lg transition active:scale-95 ${isConnected
                  ? "bg-emerald-50 text-emerald-600 hover:bg-emerald-100"
                  : "bg-red-50 text-red-600 hover:bg-red-100"}`}
              >
                {isConnected ? <PiPlugsConnectedFill /> : <VscDebugDisconnect />}
                <span className={`absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full ${isConnected ? "bg-emerald-500" : "bg-red-500"}`} />
                <span className="sr-only">{isConnected ? "Connected" : "Disconnected"}</span>
              </button>

              {/* center info */}
              {centerData &&
                <div className="flex flex-col items-center text-center text-gray-700">
                  <div className="text-2xl font-bold text-gray-900">{centerData.centerName}</div>
                  {/* <div className="text-md flex items-center gap-1 text-gray-600">
                    <MdOutlineLocationOn className="shrink-0 text-brand-500" />
                    <span>{centerData.address}</span>
                  </div> */}
                  <div className="flex items-center gap-1 text-sm text-gray-500">
                    <span className="flex items-center gap-1.5">
                      <MdOutlineSupportAgent className="text-lg text-brand-500" /> Reception
                    </span> <MdOutlineAccessTime className="shrink-0" />
                    {moment(centerData.opdStartTime).format("LT")} - {moment(centerData.opdEndTime).format("LT")}
                  </div>
                </div>
              }
            </div>
          }
        >
          {/* doctor status segmented control */}
          <div className="flex justify-center sm:justify-end md:-mt-12">
            <div className="flex max-w-full gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1">
              {DOCTOR_STATES.map(({ id, label, Icon, color }) => (
                <button
                  key={id}
                  type="button"
                  onClick={() => GetDoctorChangeStatus(id)}
                  aria-pressed={doctorStatus == id}
                  className={`flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm ${doctorStatus == id ? `${color} text-white shadow` : "text-gray-500 hover:bg-white hover:text-gray-700"}`}
                >
                  <Icon className="text-sm sm:text-base" />
                  {label}
                </button>
              ))}
            </div>
          </div>







          {/* OPD flow controls */}
          {doctorStatus == 1 &&
            <div className="mt-4 flex flex-wrap items-center justify-center gap-2 sm:justify-end">
              {/* abhi chal rahi repeat announcement */}
              {notice &&
                <div className="mt-3 flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5">
                  <MdCampaign className="mt-0.5 shrink-0 text-lg text-amber-600" />
                  <div className="flex-1">
                    <div className="text-sm font-semibold text-amber-900">{notice.text}</div>
                    <div className="text-xs text-amber-700">{noticeLabel(notice)}</div>
                  </div>
                  <button
                    type="button"
                    onClick={stopNotice}
                    className="inline-flex shrink-0 items-center gap-1 rounded-lg bg-red-500 px-3 py-2 text-xs font-semibold text-white transition hover:bg-red-600 active:scale-95"
                  >
                    <MdStop className="text-base" /> Stop
                  </button>
                </div>
              }
              {/* announcement bar — doctor status kuch bhi ho, hamesha available */}
              <div className="flex flex-wrap items-center justify-center gap-2 sm:justify-end">
                <div className="inline-flex overflow-hidden rounded-xl shadow">
                  <button
                    type="button"
                    onClick={() => setIsOpenAnnounce(true)}
                    title="Waiting room screen par apna message bolwayein"
                    className="inline-flex items-center gap-2 bg-brand-500 px-5 py-3 text-sm font-semibold text-white transition hover:bg-brand-600 focus:ring-2 focus:ring-brand-500 active:scale-95 sm:px-6"
                  >
                    <MdCampaign className="text-lg" /> Announcement
                  </button>
                  <button
                    type="button"
                    onClick={toggleSpeakHere}
                    aria-pressed={speakHere}
                    title={speakHere
                      ? "Is device par bhi awaaz aayegi — band karne ke liye tap karein"
                      : "Sirf Display screen bolegi — yahan bhi bolwane ke liye tap karein"}
                    className={`grid w-11 place-items-center border-l border-white/25 text-lg transition active:scale-95 ${speakHere
                      ? "bg-brand-600 text-white"
                      : "bg-brand-500 text-white/60 hover:text-white"}`}
                  >
                    {speakHere ? <MdVolumeUp /> : <MdVolumeOff />}
                    <span className="sr-only">Speak on this device</span>
                  </button>
                </div>
              </div>
              <button
                type="button"
                title='Shift + s for next patient or start opd.'
                onClick={() => {
                  setIsOpenPop(!isOpenPop)
                  currentData
                    ? setEventMessages("Are you sure to call Next Patient?")
                    : setEventMessages("Are you sure to Start OPD?")
                }}
                className="inline-flex items-center gap-2 rounded-xl bg-green-500 px-5 py-3 text-sm font-semibold text-white shadow transition hover:bg-green-400 focus:ring-2 focus:ring-green-500 active:scale-95 sm:px-6"
              >
                {currentData
                  ? <><MdSkipNext className="text-lg" /> Next Patient</>
                  : <><MdPlayArrow className="text-lg" /> Start OPD</>}
              </button>

              {currentData &&
                <>
                  <button
                    type="button"
                    onClick={() => {
                      setIsOpenUnavailable(!isOpenUnavailable)
                      setEventMessages("Are you sure to send current patient in the cabin to unavailable?")
                    }}
                    className="inline-flex items-center gap-2 rounded-xl bg-orange-500 px-5 py-3 text-sm font-medium text-white shadow transition hover:bg-orange-400 focus:ring-2 focus:ring-orange-500 active:scale-95 sm:px-6"
                  >
                    <MdOutlinePersonOff className="text-lg" /> Unavailable
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setIsOpenAbsent(!isOpenAbsent)
                      setEventMessages("Are you sure to send current patient in the cabin to Absent?")
                    }}
                    className="inline-flex items-center gap-2 rounded-xl bg-red-500 px-5 py-3 text-sm font-semibold text-white shadow transition hover:bg-red-400 focus:ring-2 focus:ring-red-500 active:scale-95 sm:px-6"
                  >
                    <MdOutlineCancel className="text-lg" /> Absent
                  </button>
                </>}
            </div>}
        </Card>
        <div className="my-2" />
        <DaillyShortReport refresh={isDailyUpdate} />

        {/* ===== Main ===== */}
        <div className="flex flex-col gap-4 md:flex-row md:items-start">

          {/* left: tabs + content */}
          <div className="order-2 md:order-1 md:w-8/12 lg:w-9/12">
            <Card isBorder={true}>
              <div className="flex flex-col gap-2">
                {/* tabs + add */}
                <div className="flex items-center gap-2">
                  <div className="flex flex-1 gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1">
                    {TABS.map(({ id, label, Icon, color }) => (
                      <button
                        key={id}
                        type="button"
                        onClick={() => selectTab(id)}
                        aria-pressed={viewUsers == id}
                        className={`flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm ${viewUsers == id ? `${color} text-white shadow` : "text-gray-500 hover:bg-white hover:text-gray-700"}`}
                      >
                        <Icon className="text-sm sm:text-base" />
                        {label}
                      </button>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={() => { setIsOpenAdd(!isOpenAdd); setIsPrint(false) }}
                    title="Add OPD"
                    className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-green-600 text-xl text-white shadow transition hover:bg-green-700 focus:ring-2 focus:ring-green-500 active:scale-95"
                  >
                    <IoMdAdd />
                    <span className="sr-only">Add OPD</span>
                  </button>
                </div>

                {/* search (available on all sizes) */}
                <div className="flex items-center gap-2">
                  <div className="relative w-full">
                    <MdSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-gray-400" />
                    <input
                      type="text"
                      value={serachPatient}
                      onChange={(e) => setSerachPatient(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          doSearch();
                        }
                      }}
                      placeholder={`Search ${searchScope} patient...`}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 pl-10 pr-9 text-sm text-gray-900 outline-none focus:border-blue-500 focus:ring-blue-500"
                    />
                    {serachPatient &&
                      <button
                        type="button"
                        onClick={() => { setSerachPatient(""); doSearch(); }}
                        className="absolute right-2 top-1/2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-full text-gray-400 transition hover:bg-gray-200 hover:text-gray-600"
                      >
                        <MdClose className="text-base" />
                        <span className="sr-only">Clear search</span>
                      </button>
                    }
                  </div>
                  <button
                    onClick={doSearch}
                    className="grid h-10 w-10 shrink-0 place-items-center rounded-lg border border-brand-600 bg-brand-500 text-white transition hover:bg-brand-600 focus:outline-none focus:ring-4 focus:ring-brand-600/40"
                  >
                    <MdSearch className="text-lg" />
                    <span className="sr-only">Search</span>
                  </button>
                </div>
              </div>

              {/* tab content — key badalte hi component remount hota hai = fresh data */}
              <div className="mt-3">
                {viewUsers == 1 && <ReceptionRegistered key={`reg-${tabRefresh}`} isActive={viewUsers == 1} searchTerm={serachPatient} isSearch={isSerachPatient} />}
                {viewUsers == 2 && <ReceptionConfirmed key={`con-${tabRefresh}`} isActive={viewUsers == 2} searchTerm={serachPatient} isSearch={isSerachPatient} />}
                {viewUsers == 3 && <ReceptionEmergency key={`emg-${tabRefresh}`} isActive={viewUsers == 3} searchTerm={serachPatient} isSearch={isSerachPatient} />}
              </div>
            </Card>
          </div>

          {/* right: current + next (shown first on mobile) */}
          <div className="order-1 flex flex-col gap-4 md:order-2 md:sticky md:top-[80px] md:w-4/12 lg:w-3/12">
            <Card isBorder={true} borderColor="border-green-500">
              {loding ? (
                <LoadingContainer text="Please wait..." />
              ) : (
                <div className="py-4 text-center text-gray-700">
                  {currentData ? (
                    <>
                      <div className="flex items-center justify-center gap-1.5 text-sm font-semibold uppercase tracking-wide text-gray-400">
                        <FaUserMd className="text-green-500" /> Current Patient
                      </div>
                      <div className="mt-2"><PatientBody data={currentData} /></div>
                      <button
                        type="button"
                        onClick={AnnounceCabin}
                        title="Announce again"
                        className="mt-3 inline-flex items-center gap-1.5 rounded-lg bg-brand-500/10 px-3 py-2 text-xs font-semibold text-brand-600 transition hover:bg-brand-500/20 active:scale-95"
                      >
                        <MdCampaign className="text-base" /> Announce Again
                      </button>
                    </>
                  ) : (
                    <div className="flex flex-col items-center gap-2 py-8">
                      <MdPlayArrow className="text-3xl text-green-500" />
                      <div className="text-xl font-semibold">Please Start OPD</div>
                    </div>
                  )}
                </div>
              )}
            </Card>

            {nextPatientData &&
              <Card isBorder={true} borderColor="border-brand-500">
                {loding ? (
                  <LoadingContainer text="Please wait..." />
                ) : (
                  <div className="py-4 text-center text-gray-700">
                    <div className="flex items-center justify-center gap-1.5 text-sm font-bold uppercase tracking-wide text-brand-500">
                      <MdSkipNext className="text-lg" /> Next Patient
                    </div>
                    <div className="mt-2"><PatientBody data={nextPatientData} /></div>
                    <button
                      type="button"
                      onClick={AnnounceNext}
                      title="Announce next patient again"
                      className="mt-3 inline-flex items-center gap-1.5 rounded-lg bg-brand-500/10 px-3 py-2 text-xs font-semibold text-brand-600 transition hover:bg-brand-500/20 active:scale-95"
                    >
                      <MdCampaign className="text-base" /> Announce Next
                    </button>
                  </div>
                )}
              </Card>
            }
          </div>
        </div>
      </div>

      <AddOpdOffline addOpdOffline={addOpdOffline} currentSavedData={currentSavedData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} isPrint={isPrint} setIsPrint={setIsPrint} />
      <AnnouncePopUp isOpen={isOpenAnnounce} setIsOpen={setIsOpenAnnounce} onSend={sendNotice} onStop={stopNotice} active={notice} loding={loding} />
      <WarningPopUp call={NextPatient} isOpen={isOpenPop} setIsOpen={setIsOpenPop} loding={loding} text={eventMessage} />
      <WarningPopUp call={PatientUnavailable} isOpen={isOpenUnavailable} setIsOpen={setIsOpenUnavailable} loding={loding} text={eventMessage} />
      <WarningPopUp call={SetToAbsent} isOpen={isOpenAbsent} setIsOpen={setIsOpenAbsent} loding={loding} text={eventMessage} />

    </Container>
  )
}